/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Type} from '@angular/core';

import {ActiveOompaLoompa} from './chocolate/active-oompa-loompa';
import {TabsWillyWonka} from './chocolate/tabs-willy-wonka';
import {Tab} from './tab';
import {TabContent} from './tab-content';
import {TabLinkDirective} from './tab-link.directive';
import {TabOverflowContent} from './tab-overflow-content';
import {Tabs} from './tabs';

export {Tabs} from './tabs';
export {Tab} from './tab';
export {TabContent} from './tab-content';
export {TabOverflowContent} from './tab-overflow-content';
export {TabLinkDirective} from './tab-link.directive';

export const /** @type {?} */ TABS_DIRECTIVES: Type<any>[] =
    [TabContent, Tab, Tabs, TabOverflowContent, TabLinkDirective, TabsWillyWonka, ActiveOompaLoompa];
